import { request } from '@kibt/krn-utils';
import { api } from '@/common/api';

/***
 * 将这两个基本的不依赖node-forge的单独摘出来，防止其他的只依赖这两个引用，额外引入了node-forge
 */

// 加解密接口encryptionFormat所需要的参数配置
export const APPID = '1';
export const BIZ_TYPE = '1';
export const VERSION = '1';

export const getEncryptionFormat = (algorithm = 1) => {
    return {
        algorithm,
        appId: APPID,
        bizType: BIZ_TYPE,
        version: VERSION,
    };
};

/**
 * 查询AES加密参数
 */
export function getAesKey(params: { appId: string; bizType: string; version: string }) {
    return request.post(api('/rest/o/ecommerce/privacy/encryption/aes/param/query'), params);
}
